<div class="content-wrapper reports-container">
  <div class="col-md-12 layout-spacing" style="margin-top: 19px">
    <div class="widget quick-category" style="display: flex">
      <div class="quick-category-content header">
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.fileName' | translate }}
          </span>
          <span
            class="header-title"
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ file?.fileName }}"
          >
            {{ (file?.fileName | cutString : 40) || '-' }}
          </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.owner' | translate }}
          </span>
          <span
            class="header-label"
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ file?.ownerUser }}"
          >
            {{ (file?.ownerUser | cutString : 20) || '-' }}
          </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.creationDate' | translate }}
          </span>
          <span class="header-label">
            {{ (file?.creationDate | tableDate) || '-' }}
          </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.endDate' | translate }}
          </span>
          <span class="header-label">
            {{ file?.expirationDate | tableDate }}
          </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.originalPlace' | translate }}
          </span>
          <span class="header-label"> {{ file?.location || '-' }} </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.fileType' | translate }}
          </span>
          <span class="header-label"> {{ file?.fileType || '-' }} </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.label' | translate }}
          </span>
          <span
            class="header-label"
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ file?.label }}"
          >
            {{ (file?.label | cutString : 20) || '-' }}
          </span>
        </div>
        <div class="header-section">
          <span class="header-subtitle">
            {{ 'utilities.table.lastUpdate' | translate }}
          </span>
          <span class="header-label">
            {{ (file?.modificationDate | tableDate) || '-' }}
          </span>
          <span class="header-label">
            {{ file?.modificationUser || '-' }}
          </span>
        </div>
      </div>
      <div style="margin-top: 1rem">
        <button
          style="
            padding: 5px 25px;
            width: 100px;
            height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6px;
            font-size: 0.9rem;
          "
          type="button"
          class="btn btn-primary"
          (click)="goBack()"
        >
          {{ 'utilities.table.return' | translate }}
        </button>
      </div>
    </div>

    <div class="card-box" style="margin-top: 3rem">
      <div class="w-100 animated-underline-content">
        <ul class="nav nav-tabs mb-3" id="lineTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              id="underline-resume-tab"
              data-toggle="tab"
              href="#underline-resume"
              role="tab"
              aria-controls="underline-resume"
              aria-selected="true"
              (click)="currentTab = 1"
              >{{ 'utilities.table.summary' | translate }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="underline-history-tab"
              data-toggle="tab"
              href="#underline-history"
              role="tab"
              aria-controls="underline-history"
              aria-selected="false"
              (click)="currentTab = 2"
              >{{ 'utilities.table.history' | translate }}</a
            >
          </li>
        </ul>
        <div *ngIf="currentTab === 1">
          <app-resume [id]="id"></app-resume>
        </div>
        <div *ngIf="currentTab === 2">
          <app-history [id]="id"></app-history>
        </div>
      </div>
    </div>
  </div>
</div>
